import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/Users/markyctian/nes-design/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { CheckBox, CheckboxGroup, Table } from '@components';
import { Playground, TagVersion, Explain } from 'docz';
import { Props } from './config';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h2 {...{
      "id": "checkbox"
    }}>{`Checkbox`}</h2>
    <TagVersion component="Checkbox" mdxType="TagVersion" />
    <h2 {...{
      "id": "use-and-import"
    }}>{`Use and Import`}</h2>
    <Explain component="Checkbox" isCopyable mdxType="Explain" />
    <h2 {...{
      "id": "case"
    }}>{`Case`}</h2>
    <Playground __position={2} __code={'() => {\n  const [checked, setChecked] = useState(false)\n  return (\n    <CheckBox checked={checked} onChange={e => setChecked(e.target.checked)}>\n      {\' \'}\n      Yes{\' \'}\n    </CheckBox>\n  )\n}'} __scope={{
      props,
      DefaultLayout,
      CheckBox,
      CheckboxGroup,
      Table,
      Playground,
      TagVersion,
      Explain,
      Props,
      DefaultLayout,
      _frontmatter
    }} wrapper="CheckBox" mdxType="Playground">
  {() => {
        const [checked, setChecked] = useState(false);
        return <CheckBox checked={checked} onChange={e => setChecked(e.target.checked)} mdxType="CheckBox"> Yes </CheckBox>;
      }}
    </Playground>
    <Playground __position={3} __code={'() => {\n  const [value, setValue] = useState([])\n  return (\n    <>\n      <CheckboxGroup\n        value={value}\n        options={[\n          { label: \'Yes\', value: \'yes\', defaultChecked: true },\n          { label: \'No\', value: \'no\' },\n        ]}\n        onChange={values => setValue(values)}\n      />\n      <CheckboxGroup\n        theme=\"dark\"\n        style={{\n          display: \'flex\',\n          background: \'black\',\n          height: 50,\n          alignItems: \'center\',\n        }}\n        value={value}\n        options={[\n          { label: \'Yes\', value: \'yes\', defaultChecked: true },\n          { label: \'No\', value: \'no\' },\n        ]}\n        onChange={values => setValue(values)}\n      />\n    </>\n  )\n}'} __scope={{
      props,
      DefaultLayout,
      CheckBox,
      CheckboxGroup,
      Table,
      Playground,
      TagVersion,
      Explain,
      Props,
      DefaultLayout,
      _frontmatter
    }} wrapper="CheckboxGroup / Option is Object" mdxType="Playground">
  {() => {
        const [value, setValue] = useState([]);
        return <>
          <CheckboxGroup value={value} options={[{
            label: 'Yes',
            value: 'yes',
            defaultChecked: true
          }, {
            label: 'No',
            value: 'no'
          }]} onChange={values => setValue(values)} mdxType="CheckboxGroup" />
          <CheckboxGroup theme="dark" style={{
            display: 'flex',
            background: 'black',
            height: 50,
            alignItems: 'center'
          }} value={value} options={[{
            label: 'Yes',
            value: 'yes',
            defaultChecked: true
          }, {
            label: 'No',
            value: 'no'
          }]} onChange={values => setValue(values)} mdxType="CheckboxGroup" />
        </>;
      }}
    </Playground>
    <Playground __position={4} __code={'() => {\n  const [value, setValue] = useState([])\n  return (\n    <CheckboxGroup\n      value={value}\n      options={[\'Yes\', \'No\']}\n      onChange={values => setValue(values)}\n    />\n  )\n}'} __scope={{
      props,
      DefaultLayout,
      CheckBox,
      CheckboxGroup,
      Table,
      Playground,
      TagVersion,
      Explain,
      Props,
      DefaultLayout,
      _frontmatter
    }} wrapper="CheckboxGroup / Option is string" mdxType="Playground">
  {() => {
        const [value, setValue] = useState([]);
        return <CheckboxGroup value={value} options={['Yes', 'No']} onChange={values => setValue(values)} mdxType="CheckboxGroup" />;
      }}
    </Playground>
    <Playground __position={5} __code={'() => {\n  const [value, setValue] = useState([\'orange\'])\n  return (\n    <CheckboxGroup\n      value={value}\n      options={[\n        { label: \'Apple\', value: \'apple\', defaultChecked: true },\n        { label: \'Banana\', value: \'banana\' },\n      ]}\n      onChange={values => setValue(values)}\n    >\n      <CheckBox\n        labelProps={{ style: { display: \'block\' } }}\n        value=\"orange\"\n        children=\"Orange\"\n      />\n    </CheckboxGroup>\n  )\n}'} __scope={{
      props,
      DefaultLayout,
      CheckBox,
      CheckboxGroup,
      Table,
      Playground,
      TagVersion,
      Explain,
      Props,
      DefaultLayout,
      _frontmatter
    }} wrapper="CheckboxGroup + CheckBox" mdxType="Playground">
  {() => {
        const [value, setValue] = useState(['orange']);
        return <CheckboxGroup value={value} options={[{
          label: 'Apple',
          value: 'apple',
          defaultChecked: true
        }, {
          label: 'Banana',
          value: 'banana'
        }]} onChange={values => setValue(values)} mdxType="CheckboxGroup">
          <CheckBox labelProps={{
            style: {
              display: 'block'
            }
          }} value="orange" children="Orange" mdxType="CheckBox" />
        </CheckboxGroup>;
      }}
    </Playground>
    <Playground __position={6} __code={'() => {\n  const [value, setValue] = useState([\'orange\'])\n  return (\n    <>\n      <CheckboxGroup\n        disabled\n        value={value}\n        options={[{ label: \'Apple\', value: \'apple\', defaultChecked: true }]}\n        onChange={values => setValue(values)}\n      />\n      <CheckBox disabled defaultChecked>\n        {\' \'}\n        Banana{\' \'}\n      </CheckBox>\n    </>\n  )\n}'} __scope={{
      props,
      DefaultLayout,
      CheckBox,
      CheckboxGroup,
      Table,
      Playground,
      TagVersion,
      Explain,
      Props,
      DefaultLayout,
      _frontmatter
    }} wrapper="disabled" mdxType="Playground">
  {() => {
        const [value, setValue] = useState(['orange']);
        return <>
          <CheckboxGroup disabled value={value} options={[{
            label: 'Apple',
            value: 'apple',
            defaultChecked: true
          }]} onChange={values => setValue(values)} mdxType="CheckboxGroup" />
          <CheckBox disabled defaultChecked mdxType="CheckBox"> Banana </CheckBox>
        </>;
      }}
    </Playground>
    <h2 {...{
      "id": "props"
    }}>{`Props`}</h2>
    <>
  {[Props.public, Props.checkboxGroup, Props.checkbox, Props.option].map(({
        columns,
        data,
        footer
      }) => <div style={{
        marginTop: 20
      }}>
        <Table theme="dark" columns={columns} data={data} footer={() => <div style={{
          height: 60,
          borderTop: '4px solid white',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
              {footer}
            </div>} mdxType="Table" />
      </div>)}
    </>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      